
<!-- heyy {{ menuData | json }}

route {{ this.currentRoute | json }}
tes {{ this.tes | json }}  -->
<div class="dealer-menu">
  <!-- <h2>Menu</h2> -->

  <h5>
    <a routerLink='/car/dashboard' [class.active]="currentRoute === '/car/dashboard'" class="menu-item">
      Tableau de bord
    </a>
  </h5>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Leaf nodes  nodes with no children -->
    <mat-tree-node *matTreeNodeDef="let node"  >
      <!-- <a [routerLink]="node.link" [class.active]="node.link === currentRoute"> -->
      <h6>
        <a [routerLink]="[node.link]" [class.active]="node.link === currentRoute" class="menu-item">

          {{ node.title }}
          @if ( ! node.noQuantity) {
            <span class="qty">({{  node.quantity === undefined ? 0 : node.quantity }})</span>
          }
          @if (node.children !== undefined) {
            <button mat-icon-button >
              <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
          }
        </a>
      </h6>
    </mat-tree-node>

    <!-- Nested nodes  meaning nodes with children -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <!-- <h4 class="menu-item" matTreeNodeToggle [class.active]="node.link === currentRoute" *ngIf="node.quantity > 0"> -->
      <h5 class="menu-item" matTreeNodeToggle [class.active]="node.link === currentRoute">

        {{ node.title }}
        @if (node.quantity !== undefined && ! node.noQuantity) {
          <span class="qty">({{ node.quantity }})</span>
        }
        <button mat-icon-button >
          <mat-icon (click)="fetchNodeData(node)">{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
      </h5>

      <div [@expandCollapse]="treeControl.isExpanded(node) ? 'expanded' : 'collapsed'" class="children">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>

</div>
